import React from 'react';

const TicketContext = React.createContext();

export default TicketContext;